

<!-- Start of Quick search common component -->
  <app-quick-search 
    [DefaultFilterArray]="DefaultFilterArray"
    [QuickSearchFilterArray]="quickFilterArray"
    (updateDefaultArray)="updateDefaultArray($event)"
    (clearQuickSearch)="clearQuickSearch($event)">
  </app-quick-search>
<!-- End of Quick search common component -->

<!--Filter Code  -->
<div class="col-lg-12 nopadding">
  <app-filter-panel 
  [GridColumns]="GridColumns" 
  [DefaultFilterArray]="DefaultFilterArray"
  (FilterEvent)="FilterApplyFilterEvent($event)"
  (FilterEventClearSymbol)="FilterEventClearSymbol($event)"
  [isDatefilterDropdown]="true"
  >
  </app-filter-panel>
</div>

<!-- Filter Quick Fields Panel Code -->
<div class="col-lg-12 nopadding">
  <app-symbol-panel
   id="allocation_symbol"
   [SymbolArray]="SymbolsArray" 
   [rowCount]="totalRecords" 
   [rowCountSymbol]="totalRecords" 
   (ActiveSymbolEvent)="setActiveSymbolEvent($event)" 
   >
  </app-symbol-panel>
</div>

<!--Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(isLoadingResults) {
    <div class="example-loading-shade">
      <mat-spinner></mat-spinner>
    </div>
  }
  <app-grid
   id="allocation_grid"
   [GridColumns]="GridColumns" 
   [OptedExportCSVGridColumns]="AllocationsOptedExportCSVGridColumns" 
   [Dataset]="dataset"
   PageName="Allocation" 
   [TotalRecords]="totalRecords"
   [SymbolFilter]="ActiveSymbol" 
   (RestSymbolEvent)="GridResetSymbolEvent($event)" 
   (RestLimitEvent)="GridChangeLimitEvent($event)"
   (exportData)="exportToCSV($event)"
   [displayTildCount]="displayTildCount"
   >
  </app-grid>
</div>


